import Watcher from './Watcher';

export default function SetDataVnodeWatchers (data, row, callback) {
    let watchers = [];
    let hash = {};
    for (let item of row) {
        if (hash[item]) continue;
        watchers.push(new Watcher(data, item, function(newVal, oldVal){
            if (newVal !== oldVal) {
                callback && callback(item);
            }
        }));
    }
    return watchers;
}